
<template>
  <div class="home">
    <NavBar />
    <div class="p-3">
    <div class="d-flex justify-content-center">
      <div class="shrink-text" style="background-color: #181a1b; border-radius: 10px; padding-top: 20px;">
        <h1 class="center">Assessments at a Glance</h1>
        <h4 class="center">Last 5 Assessments</h4>
        <AssessmentChart :assessments="dispatchAssessments" />
        <div class="center">
          <CandidateTable :assessments="dispatchAssessments" />
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue'
import AssessmentChart from '@/components/DashboardComponents/Admin/AssessmentChart.vue';
import CandidateTable from '@/components/DashboardComponents/Admin/CandidateTable.vue';
import { getCookie } from '@/utils/cookies/cookieUtils';
import { endpoint } from '@/utils/endpoint/endpointUtils';


export default {
  name: 'DashboardView',
  components: {
      NavBar,
      AssessmentChart,
      CandidateTable
  },
  async mounted() {
    await this.grabRecentAssessments();
  },
  data() {
    return {
      dispatchAssessments: []
    }
  },
  methods: {
    async grabRecentAssessments() {
        try {
            const userid = getCookie('userid');
            const response = await fetch(endpoint + '/api/Assessments/GetRecentAssessmentsForDispatchUser/' + userid, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + getCookie('token'),
                'Content-Type': 'application/json',
            }});

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log(data.assessments);
            this.dispatchAssessments = data.assessments;
        } catch(exception) {}
    }
  }
}
</script>
<style>
.dashboard {
    margin: 0;
    padding: 0;
    background-color: #181a1b;
}

.home {
    margin: 0;
    padding: 0;
    background-image: url('../assets/home-background.png'); /* Replace 'path/to/your/image.jpg' with the path to your image */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    
}

/* Media query for smaller screens */
@media screen and (max-width: 768px) {
  .container {
    padding: 10px;
  }

  .center {
    text-align: center; /* Center align text on smaller screens */
  }

  .shrink-text {
    /* padding: 10px; Adjust the padding as needed */
    font-size: 10px;
    padding-right: 10px;
  }
}
</style>